import React, { useEffect, useState } from "react";
import Section from "../components/Section.jsx";
import EventCard from "../components/EventCard.jsx";
import { apiWeekend } from "../api/events.js";

export default function WeekendPage() {
  const [items, setItems] = useState([]);
  useEffect(()=>{ apiWeekend().then(setItems); },[]);

  return (
    <main className="mx-auto max-w-7xl px-4 py-8">
      <Section title="This Weekend">
        <div className="grid grid-cols-2 gap-3 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((e)=> <EventCard key={e.id} item={e} compact />)}
        </div>
      </Section>
    </main>
  );
}
